export default "     <!-- <pdf-viewer [src]=\"src\" [render-text]=\"true\" ></pdf-viewer> -->"